import { render, staticRenderFns } from "./SymbolsPreview.vue?vue&type=template&id=65dcea20&"
import script from "./SymbolsPreview.vue?vue&type=script&lang=js&"
export * from "./SymbolsPreview.vue?vue&type=script&lang=js&"
import style0 from "./SymbolsPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports